module.exports = __webpack_public_path__ + "static/media/a-long-story.9d0cbe8b.jpg";